import classNames from 'classnames';
import { ChangeEvent, FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';

import { ACCEPTED_IMAGE_FORMATS } from './ImageField.constants';
import styles from './ImageField.styles.m.css';
import { IImageFieldProps, ImageType } from './ImageField.types';
import { ImageFieldEmpty } from './ImageFieldEmpty/ImageFieldEmpty';

export const ImageField: FC<IImageFieldProps> = (props) => {
  const {
    className = '',
    name,
    value,
    renderImage,
    emptyImage,
    type = ImageType.ROUND,
    onChange,
    onLoad,
  } = props;
  const { t } = useTranslation();

  const handleAddImage = (event: ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0];
    const reader = new FileReader();

    if (file) {
      reader.readAsDataURL(file);

      reader.onload = (): void => {
        if (!reader.result) {
          return;
        }

        onLoad?.({
          type,
          image: reader.result as string,
          onChange(url: string) {
            onChange?.(url);
          },
        });
      };

      // need to upload the same file twice
      event.target.value = '';
    }
  };

  const handleRemoveImage = (): void => onChange?.('');

  const hasImage = Boolean(value);
  const url = typeof value === 'string' ? value : '';
  const noImage = emptyImage || <ImageFieldEmpty type={type} />;

  return (
    <>
      <div className={classNames(styles.container, className)}>
        <div className={styles.image}>{hasImage && renderImage ? renderImage(url) : noImage}</div>
        <div className={styles.content}>
          <div>
            <Button
              theme="primary"
              className={styles.upload}
              size="0"
              tabIndex={-1}
            >
              <input
                name={name}
                onChange={handleAddImage}
                className={styles.fileInput}
                accept={ACCEPTED_IMAGE_FORMATS}
                type="file"
              />
              <span className={styles.uploadText}>
                {hasImage ? t('avatar_update_button') : t('group_chat_photo_upload_button')}
              </span>
            </Button>
            {hasImage && (
              <Button
                className={styles.removeAvatar}
                onClick={handleRemoveImage}
                size="0"
                theme="text-primary"
              >
                {t('avatar_delete_button')}
              </Button>
            )}
          </div>
          <div className={styles.description}>{t('avatar_update_hint')}</div>
        </div>
      </div>
    </>
  );
};
